/**
 * Project Details Modal Dialog Module
 * Uses native HTML5 <dialog> with accessible focus management and keyboard handling.
 */

import { portfolioData } from '../data/portfolio-data.js';

export function initProjectModal() {
  const modal = document.getElementById('projectModal');
  if (!modal) return;

  const closeBtn = modal.querySelector('.modal-close-btn');
  const modalFooterCloseBtn = modal.querySelector('.modal-footer-close');
  const modalTag = modal.querySelector('#modalTag');
  const modalTitle = modal.querySelector('#modalTitle');
  const modalCompany = modal.querySelector('#modalCompany');
  const modalRole = modal.querySelector('#modalRole');
  const modalPeriod = modal.querySelector('#modalPeriod');
  const modalLocation = modal.querySelector('#modalLocation');
  const modalSummary = modal.querySelector('#modalSummary');
  const modalResponsibilities = modal.querySelector('#modalResponsibilities');
  const modalResults = modal.querySelector('#modalResults');

  let lastActiveElement = null;

  function openProjectModal(projectId) {
    const project = portfolioData.projects.find((p) => p.id === projectId);
    if (!project) return;

    lastActiveElement = document.activeElement;

    // Populate content
    if (modalTag) modalTag.textContent = project.tag;
    if (modalTitle) modalTitle.textContent = project.title;
    if (modalCompany) modalCompany.textContent = project.company;
    if (modalRole) modalRole.textContent = project.role;
    if (modalPeriod) modalPeriod.textContent = project.period;
    if (modalLocation) modalLocation.textContent = project.location;
    if (modalSummary) modalSummary.textContent = project.summary;

    if (modalResponsibilities) {
      modalResponsibilities.innerHTML = project.responsibilities
        .map((r) => `<li>${r}</li>`)
        .join('');
    }

    if (modalResults) {
      modalResults.innerHTML = project.results
        .map((res) => `<li>${res}</li>`)
        .join('');
    }

    modal.showModal();
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.close();
    if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
      lastActiveElement.focus();
    }
  }

  // Event delegation for opening modal from project cards
  document.querySelectorAll('[data-open-modal]').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const projectId = trigger.getAttribute('data-open-modal');
      openProjectModal(projectId);
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (modalFooterCloseBtn) modalFooterCloseBtn.addEventListener('click', closeModal);

  // Close when clicking modal backdrop
  modal.addEventListener('click', (e) => {
    const rect = modal.getBoundingClientRect();
    const isInDialog =
      rect.top <= e.clientY &&
      e.clientY <= rect.top + rect.height &&
      rect.left <= e.clientX &&
      e.clientX <= rect.left + rect.width;

    if (!isInDialog) {
      closeModal();
    }
  });

  // Handle escape key
  modal.addEventListener('cancel', () => {
    if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
      setTimeout(() => lastActiveElement.focus(), 50);
    }
  });
}

